import { render, staticRenderFns } from "./CarrousselHeader.vue?vue&type=template&id=344d3bb9&"
import script from "./CarrousselHeader.vue?vue&type=script&lang=js&"
export * from "./CarrousselHeader.vue?vue&type=script&lang=js&"
import style0 from "./CarrousselHeader.vue?vue&type=style&index=0&id=344d3bb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports